// extracted by mini-css-extract-plugin
export default {"Virtual":"virtual_Virtual__dPVUV","left":"virtual_left__wymZb","wrapper":"virtual_wrapper__3fSf1"};